import { render } from "./KindergartenAnalyticsView.vue?vue&type=template&id=12416824&scoped=true&ts=true"
import script from "./KindergartenAnalyticsView.vue?vue&type=script&lang=ts"
export * from "./KindergartenAnalyticsView.vue?vue&type=script&lang=ts"

import "./KindergartenAnalyticsView.vue?vue&type=style&index=0&id=12416824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12416824"]])

export default __exports__